import React, { useEffect } from "react";

import { Helmet } from "react-helmet";

import { injectScript, runAfterWindowLoad } from "@/utils/thirdPartyScripts";

const MINDBOX_TRACKER_URL = "https://api.mindbox.ru/scripts/v1/tracker.js";

/**
 * Mindbox (SEO #12, task 4575).
 *
 * Лёгкая очередь команд остаётся инлайном и выполняется сразу — события, отправленные до
 * загрузки трекера, копятся в `mindbox.queue` и уходят после его подключения.
 * Тяжёлый `tracker.js` (~95 КБ) грузится после события `load`.
 */
const MindboxHelmet = () => {
  useEffect(() => {
    runAfterWindowLoad(() =>
      injectScript(MINDBOX_TRACKER_URL, "mindbox-tracker-script"));
  }, []);

  return (
    <Helmet>
      <script>
        {`mindbox = window.mindbox || function() { mindbox.queue.push(arguments); };
        mindbox.queue = mindbox.queue || [];
        mindbox('create', {
          firebaseMessagingSenderId: "720806510059"
        });
        mindbox("webpush.create");`}
      </script>
    </Helmet>
  );
};

export default MindboxHelmet;
